<template>
  <div :class="columnClassName">
    <column-header :activeLayout="activeLayout" :columns="columns" :columnIndex="columnIndex" :components="components" :activeComponent="component" v-on:setActiveComponent="setActiveComponent"></column-header>
    <div :class="bodyClassName + ' tabulator-parent'">
      <div class="row">
        <div class="col-md-12">
          <h3><i class="fa fa-fw fa-file-pen"></i> {{ _('Forms') }}</h3>
        </div>
      </div>
      <editor-tabs id="tabNavi" :tabs="tabList" :selected="selectedTab" :id-prefix="tabIdPrefix" v-on:select="tab" />
      <div class="tab-content">
        <transition name="fade" mode="out-in">
          <div v-bind="tabPanel('productforms')" class="tab-pane active" id="productforms" v-if="isTabActive('productforms')" key="productforms">
            <div class="row">
              <div class="col-md-3 col-sm-4 filtercol">
                <div class="form-group">
                  <div class="input-group">
                    <input class="form-control" id="searchField" type="text" v-model="search" :placeholder="_('Keyword search')" />
                    <span class="input-group-btn">
                      <button type="button" class="btn btn-success"><i class="fa fa-fw fa-search"></i></button>
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-md-9 col-sm-8 filtercol newbuttoncol">
                <button class="pull-right newSelector btn btn-success addbutton" type="button" v-on:click="addFormDialog()"><i class="fa fa-fw fa-plus"></i> {{ _('Create new...') }}</button>
              </div>
            </div>	
            <Datatable :url="formsUrl" :search="search" :options="tableOptions" ref="datatableForms" v-on:data="tableEvent" :style="isModal ? 'height: 70dvh; min-height: 200px;' : ''"/>
          </div>
        </transition>
      </div>
    </div>
    <nav class="modal-footer" v-if="isModal">
      <div class="row">
        <div class="col-md-12">
          <div class="pull-right">
            <button class="btn btn-default" v-on:click="close"><i class="fa fa-fw fa-close"></i> {{ _('Close') }}</button>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>

import axios from 'axios'
import components from '~/lib/components'
import formatters from '~/lib/formatters'
import forms from '~/lib/forms'
import { Datatable } from '#components'
import debounce from 'lodash/debounce'

export default {
  data () {
    const $this = this
    const _ = useNuxtApp().$translate
    return {
      search: '',
      activeTab: 'productforms',
      tableOptions: {
        columns: [
        {
          title: 'ID',
          field: 'id',
          width: 70,
          responsive: 0
        },
        {
          title: _('Name'),
          field: 'name',
          widthGrow: 4,
          responsive: 0
        },
        ],
        initialSort: [{
          column: 'name',
          dir: 'asc'
        }],
        rowClick (e, row) {
          const id = row.getCell('id').getValue()
          const name = row.getCell('name').getValue()
          $this.editForm(id, name)
        }
      }
    }
  },
  mixins: [components, formatters, forms],
  computed: {
    tabList () {
      return this.editorTabs([
        { id: 'productforms', label: this._('Product-specific forms') }
      ])
    },
    versionStr () {
      return '&locale=' + this.locale + '&version=' + this.version
    },
    formsUrl () {
      return this.baseDomain + this.shopId + '/forms.json?apikey=' + this.apiKey + this.versionStr
    },
  },
  methods: {
    reload () {
      if (this.$refs.datatableForms) {
        this.$refs.datatableForms.reload()
      }
    }
  },
  components: {
    Datatable
  },
  mounted () {
    if(!this.events) {
      let events = {}
      events['formUpdate'] = debounce((message) => {
        return this.reload()
      }, 200)
      this.events = events
    }
    this.enableEventBus()
  }
}
</script>